"use client";

import React from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { HelpCircle } from "lucide-react";
import { cn } from "@/lib/utils";

interface TourButtonProps extends Omit<ButtonProps, "onClick"> {
    className?: string;
    tourId?: string;
    onTourStart?: () => void;
    children?: React.ReactNode;
}

export default function TourButton({
    className,
    tourId = "dashboard",
    onTourStart,
    children,
    ...props
}: TourButtonProps) {
    const startTour = () => {
        // Remove the tour completion flag from localStorage using the specific tourId
        localStorage.removeItem(`onboardingComplete_${tourId}`);

        // Call the optional callback if provided
        if (onTourStart) {
            onTourStart();
            return;
        }

        // Reload the page to start the tour if no callback is provided
        window.location.reload();
    };

    return (
        <Button
            onClick={startTour}
            variant="outline"
            size="sm"
            className={cn("w-fit", className)}
            {...props}
        >
            {children || <HelpCircle className="h-4 w-4" />}
        </Button>
    );
}
